// Announcement bar rotation
(function() {
  var msgs = document.querySelectorAll('.announcement-bar__msg');
  if (msgs.length < 2) return;
  var current = 0;
  setInterval(function() {
    msgs[current].classList.remove('active');
    current = (current + 1) % msgs.length;
    msgs[current].classList.add('active');
  }, 3500);
})();

// Hide-on-scroll-down / show-on-scroll-up for the sticky teal nav.
(function() {
  var nav = document.querySelector('.site-nav');
  if (!nav) return;
  var lastY = window.scrollY;
  var threshold = 80; // don't hide until we're past the announcement bar
  var ticking = false;
  function update() {
    var y = window.scrollY;
    if (y > threshold && y > lastY + 4) {
      nav.classList.add('is-hidden');         // scrolling down → hide
    } else if (y < lastY - 4 || y <= threshold) {
      nav.classList.remove('is-hidden');      // scrolling up → show
    }
    lastY = y;
    ticking = false;
  }
  window.addEventListener('scroll', function() {
    if (!ticking) { requestAnimationFrame(update); ticking = true; }
  }, { passive: true });
})();


// Mini-PDP: multi-product state machine (mouth, nose, ear, holder, travel).
// Pricing data + cart URLs sourced from sleepkarma.co live PDPs.
(function() {
  // Multi-product mini-PDP — data sourced from sleepkarma.co live PDPs
var PRODUCTS_DATA = {
  mouth: {
    name: 'Premium Bamboo Mouth Tape',
    subtitle: null,
    rating: { stars: '4.8', count: '1,422 reviews', recommendPct: '94% recommend' },
    badge: 'Best Seller',
    hasTapeStyle: true,
    hasPacks: true,
    hasRefill: true,
    useDualCarousel: true,
    pricing: {
      packs:    { '1': { perMonth: '$49.95', total: '$49.95'  }, '3': { perMonth: '$49.95', total: '$149.85' }, '6': { perMonth: '$49.95', total: '$299.70' } },
      subPacks: { '1': { perMonth: '$34.97', orig: '$49.95',  total: '$34.97',  save: '30% OFF' },
                  '3': { perMonth: '$27.47', orig: '$149.85', total: '$82.41',  save: '45% OFF' },
                  '6': { perMonth: '$24.98', orig: '$299.70', total: '$149.88', save: '50% OFF' } }
    },
    oneTimeUnitCents: 4995  // for the "You save $X" calc
  },
  nose: {
    name: 'Premium Bamboo Nose Tape',
    subtitle: 'Breathe Deeper. Sleep Better. Ultra-premium nasal strips engineered for silent, restorative sleep.',
    rating: { stars: '4.7', count: '306 reviews', recommendPct: null },
    image: 'Page Images/products/nose-hero.jpg',
    badge: 'Best Seller',
    hasTapeStyle: false,
    hasPacks: true,
    hasRefill: true,
    useDualCarousel: false,
    pricing: {
      packs:    { '1': { perMonth: '$38.97', total: '$38.97'  }, '3': { perMonth: '$38.97', total: '$116.91' }, '6': { perMonth: '$38.97', total: '$233.82' } },
      subPacks: { '1': { perMonth: '$27.28', orig: '$38.97',  total: '$27.28',  save: '30% OFF' },
                  '3': { perMonth: '$21.43', orig: '$116.91', total: '$64.30',  save: '45% OFF' },
                  '6': { perMonth: '$19.49', orig: '$233.82', total: '$116.91', save: '50% OFF' } }
    },
    oneTimeUnitCents: 3897
  },
  ear: {
    name: 'Quiet Night Ear Plugs',
    subtitle: 'Soft, moldable plugs for distraction-free silent nights. Pairs perfectly with mouth taping.',
    rating: null,
    image: 'Page Images/products/ear.jpg',
    badge: null,
    hasTapeStyle: false,
    hasPacks: false,
    hasRefill: false,
    useDualCarousel: false,
    simplePrice: '$19.95',
    cartUrl: 'https://sleepkarma.co/cart/add?id=46095730376945&quantity=1'
  },
  holder: {
    name: 'Sleep Tape Bedside Holder',
    subtitle: 'Bamboo Bedside Holder — keep your mouth tape neat and easy to access before bed.',
    rating: null,
    image: 'Page Images/products/holder.jpg',
    badge: null,
    hasTapeStyle: false,
    hasPacks: false,
    hasRefill: false,
    useDualCarousel: false,
    simplePrice: '$14.95',
    cartUrl: 'https://sleepkarma.co/cart/add?id=46045513154801&quantity=1'
  },
  travel: {
    name: 'Hand-Crafted Travel Case',
    subtitle: 'Premium travel case for your nightly sleep kit. Perfect for trips and overnight stays.',
    rating: null,
    image: 'Page Images/products/travel.jpg',
    badge: null,
    hasTapeStyle: false,
    hasPacks: false,
    hasRefill: false,
    useDualCarousel: false,
    simplePrice: '$24.99',
    cartUrl: 'https://sleepkarma.co/cart/add?id=46045514629361&quantity=1'
  }
};

// Override mini-PDP product images from live Shopify featured_images (set in section Liquid).
if (window.SK_PRODUCT_IMAGES) {
  Object.keys(window.SK_PRODUCT_IMAGES).forEach(function(key) {
    if (PRODUCTS_DATA[key] && window.SK_PRODUCT_IMAGES[key]) {
      PRODUCTS_DATA[key].image = window.SK_PRODUCT_IMAGES[key];
    }
  });
}

// Cart URLs for tier-based products (mouth + nose). Indexed by [productKey][packId][isSub].
var CART_URLS = {
  mouth: {
    '1': { sub: '/pages/mouth-tape-a', one: '/pages/mouth-tape-a' },
    '3': { sub: '/pages/mouth-tape-a', one: '/pages/mouth-tape-a' },
    '6': { sub: '/pages/mouth-tape-a', one: '/pages/mouth-tape-a' }
  },
  nose: {
    '1': { sub: 'https://sleepkarma.co/cart/add?id=46045510107377&quantity=1&selling_plan=5171773681',
           one: 'https://sleepkarma.co/cart/add?id=46045510107377&quantity=1' },
    '3': { sub: 'https://sleepkarma.co/cart/add?id=46045510172913&quantity=1&selling_plan=5171740913',
           one: 'https://sleepkarma.co/cart/add?id=46045510172913&quantity=1' },
    '6': { sub: 'https://sleepkarma.co/cart/add?id=46045510238449&quantity=1&selling_plan=5171806449',
           one: 'https://sleepkarma.co/cart/add?id=46045510238449&quantity=1' }
  }
};

  var mpState = { product: 'mouth', pack: '3', isSubscription: true };

  function currentPricing() { return PRODUCTS_DATA[mpState.product].pricing; }
  function currentProduct() { return PRODUCTS_DATA[mpState.product]; }

  function mpUpdatePackCards() {
    var p = currentPricing();
    if (!p) return;  // single-SKU product, packs hidden
    ['1','3','6'].forEach(function(pk) {
      var permEl = document.getElementById('mp-pack-' + pk + '-perm');
      var origEl = document.getElementById('mp-pack-' + pk + '-orig');
      var totalEl = document.getElementById('mp-pack-' + pk + '-total');
      var discountEl = document.getElementById('mp-pack-' + pk + '-discount');
      if (!permEl) return;
      if (mpState.isSubscription) {
        var sub = p.subPacks[pk];
        permEl.innerHTML = sub.perMonth + '<span class="mp-pack-perm-label">/mo</span>';
        origEl.textContent = p.packs[pk].perMonth;
        origEl.style.visibility = 'visible';
        if (discountEl) { discountEl.textContent = sub.save; discountEl.style.display = ''; }
        if (totalEl) totalEl.textContent = sub.total + ' total';
      } else {
        var one = p.packs[pk];
        permEl.innerHTML = one.perMonth + '<span class="mp-pack-perm-label">/pack</span>';
        origEl.style.visibility = 'hidden';
        if (discountEl) discountEl.style.display = 'none';
        if (totalEl) totalEl.textContent = one.total + ' total';
      }
    });
    document.querySelectorAll('.mp-pack-deliver, .mp-pack-benefits').forEach(function(el) {
      el.classList.toggle('visible', mpState.isSubscription);
    });
    var bestDeal = document.querySelector('.mp-pack-tag--best');
    if (bestDeal) bestDeal.style.display = mpState.isSubscription ? '' : 'none';
  }

  function mpUpdateUI() {
    var prod = currentProduct();
    var p = currentPricing();
    if (p) {
      var total = mpState.isSubscription ? p.subPacks[mpState.pack].total : p.packs[mpState.pack].total;
      var ctaPrice = document.getElementById('mp-cta-price');
      if (ctaPrice) ctaPrice.textContent = total;
      var ctaOrig = document.getElementById('mp-cta-orig');
      if (ctaOrig) {
        if (mpState.isSubscription) {
          ctaOrig.textContent = p.packs[mpState.pack].total;
          ctaOrig.style.display = '';
        } else {
          ctaOrig.style.display = 'none';
        }
      }
      // Update CTA href to the right cart URL
      var ctaBtn = document.getElementById('add-to-cart-btn');
      if (ctaBtn && CART_URLS[mpState.product] && CART_URLS[mpState.product][mpState.pack]) {
        var url = mpState.isSubscription
          ? CART_URLS[mpState.product][mpState.pack].sub
          : CART_URLS[mpState.product][mpState.pack].one;
        ctaBtn.href = url;
        if (url.startsWith('http')) {
          ctaBtn.target = '_blank';
          ctaBtn.rel = 'noopener';
        } else {
          ctaBtn.removeAttribute('target');
          ctaBtn.removeAttribute('rel');
        }
      }
      // Recompute "You save $X" using the current product's per-unit one-time price
      var saveBox = document.getElementById('mp-refill-save');
      if (saveBox) {
        if (mpState.isSubscription) {
          var months = parseInt(mpState.pack, 10);
          var oneTimeCents = (prod.oneTimeUnitCents || 0) * months;
          var subCents = Math.round(parseFloat(p.subPacks[mpState.pack].total.replace('$','')) * 100);
          var saved = ((oneTimeCents - subCents) / 100).toFixed(2);
          saveBox.textContent = 'You save $' + saved;
          saveBox.style.display = '';
        } else {
          saveBox.style.display = 'none';
        }
      }
    }
  }

  // Variant select (UI only — only relevant for products with hasTapeStyle)
  document.querySelectorAll('.mp-variants').forEach(function(group) {
    group.querySelectorAll('.mp-variant').forEach(function(v) {
      v.addEventListener('click', function() {
        group.querySelectorAll('.mp-variant').forEach(function(x) {
          x.classList.remove('is-selected');
          x.setAttribute('aria-checked', 'false');
        });
        v.classList.add('is-selected');
        v.setAttribute('aria-checked', 'true');
      });
    });
  });

  // Pack select
  document.querySelectorAll('.mp-packs').forEach(function(group) {
    group.querySelectorAll('.mp-pack').forEach(function(p) {
      p.addEventListener('click', function() {
        group.querySelectorAll('.mp-pack').forEach(function(x) { x.classList.remove('is-selected'); });
        p.classList.add('is-selected');
        mpState.pack = p.getAttribute('data-pack');
        mpUpdatePackCards();
        mpUpdateUI();
      });
    });
  });

  // Refill (subscription) toggle
  var mpRefill = document.getElementById('mp-refill');
  if (mpRefill) {
    mpRefill.addEventListener('click', function() {
      mpState.isSubscription = !mpState.isSubscription;
      mpRefill.classList.toggle('is-active', mpState.isSubscription);
      mpRefill.setAttribute('aria-pressed', String(mpState.isSubscription));
      var check = document.getElementById('mp-refill-check');
      if (check) check.textContent = mpState.isSubscription ? '✓' : '';
      mpUpdatePackCards();
      mpUpdateUI();
    });
  }

  // Multi-product swap — called when category tabs are clicked
  window.swapProduct = function(key) {
    var prod = PRODUCTS_DATA[key];
    if (!prod) return;
    mpState.product = key;
    mpState.pack = '3';  // reset to default pack
    // Reset selected pack visually
    document.querySelectorAll('.mp-pack').forEach(function(x) { x.classList.remove('is-selected'); });
    var defaultPack = document.querySelector('.mp-pack[data-pack="3"]');
    if (defaultPack) defaultPack.classList.add('is-selected');

    // Title + subtitle
    var titleEl = document.getElementById('mp-title');
    if (titleEl) titleEl.textContent = prod.name;
    var subEl = document.getElementById('mp-subtitle');
    if (subEl) {
      if (prod.subtitle) { subEl.textContent = prod.subtitle; subEl.style.display = ''; }
      else { subEl.style.display = 'none'; }
    }

    // Rating row
    var ratingEl = document.getElementById('mp-rating');
    if (prod.rating) {
      ratingEl.style.display = '';
      var s = document.getElementById('mp-rating-stars'); if (s) s.textContent = prod.rating.stars;
      var c = document.getElementById('mp-rating-count'); if (c) c.textContent = prod.rating.count;
      var r = document.getElementById('mp-recommend');
      if (r) {
        if (prod.rating.recommendPct) {
          r.style.display = '';
          var rp = document.getElementById('mp-recommend-pct');
          if (rp) rp.textContent = prod.rating.recommendPct;
        } else {
          r.style.display = 'none';
        }
      }
    } else {
      ratingEl.style.display = 'none';
    }

    // Badge
    var badgeEl = document.getElementById('mp-gallery-badge');
    if (badgeEl) {
      if (prod.badge) {
        badgeEl.style.display = '';
        var bl = document.getElementById('mp-gallery-badge-label');
        if (bl) bl.textContent = prod.badge;
      } else {
        badgeEl.style.display = 'none';
      }
    }

    // Gallery: dual-carousel for mouth, single image otherwise
    var carousels = document.querySelectorAll('.mp-gallery__main .hero-carousel');
    var singleImg = document.getElementById('mp-gallery-single');
    if (prod.useDualCarousel) {
      carousels.forEach(function(c) { c.style.display = ''; });
      // Reset to first carousel (Full Coverage) being active
      carousels.forEach(function(c) {
        c.classList.toggle('is-active', c.getAttribute('data-variant') === 'full');
      });
      if (singleImg) singleImg.style.display = 'none';
    } else {
      carousels.forEach(function(c) { c.style.display = 'none'; });
      if (singleImg && prod.image) {
        singleImg.src = prod.image;
        singleImg.alt = prod.name;
        singleImg.style.display = '';
      }
    }

    // Section visibility
    var tapeGroup = document.getElementById('mp-tape-group');
    if (tapeGroup) tapeGroup.style.display = prod.hasTapeStyle ? '' : 'none';
    var packsGroup = document.getElementById('mp-packs-group');
    if (packsGroup) packsGroup.style.display = prod.hasPacks ? '' : 'none';
    var refillBtn = document.getElementById('mp-refill');
    if (refillBtn) refillBtn.style.display = prod.hasRefill ? '' : 'none';
    var tierCta = document.getElementById('add-to-cart-btn');
    if (tierCta) tierCta.style.display = prod.hasPacks ? '' : 'none';

    // Simple buy section for single-SKU products
    var simpleBuy = document.getElementById('mp-simple-buy');
    if (simpleBuy) {
      if (!prod.hasPacks) {
        simpleBuy.style.display = '';
        var sp = document.getElementById('mp-simple-price');
        if (sp) sp.textContent = prod.simplePrice;
        var sc = document.getElementById('mp-simple-cta');
        if (sc) sc.href = prod.cartUrl;
      } else {
        simpleBuy.style.display = 'none';
      }
    }

    // Reset variant selection (back to "full")
    document.querySelectorAll('.mp-variant').forEach(function(x) {
      x.classList.remove('is-selected');
      x.setAttribute('aria-checked', 'false');
    });
    var defaultVariant = document.querySelector('.mp-variant[data-variant="full"]');
    if (defaultVariant) {
      defaultVariant.classList.add('is-selected');
      defaultVariant.setAttribute('aria-checked', 'true');
    }

    // Reset refill to subscription on
    mpState.isSubscription = true;
    if (mpRefill) {
      mpRefill.classList.add('is-active');
      mpRefill.setAttribute('aria-pressed', 'true');
      var ch = document.getElementById('mp-refill-check');
      if (ch) ch.textContent = '✓';
    }

    // Recompute pricing UI for new product
    mpUpdatePackCards();
    mpUpdateUI();
  };

  // Initial render
  mpUpdatePackCards();
  mpUpdateUI();
})();

// Hero carousel — ported from lander. Handles arrows, dots, swipe, keyboard,
// and swaps visible carousel when the tape style variant changes.
(function () {
  document.querySelectorAll('[data-carousel]').forEach(function (root) {
    var track = root.querySelector('[data-track]');
    var slides = root.querySelectorAll('.hero-carousel__slide');
    var prev = root.querySelector('[data-prev]');
    var next = root.querySelector('[data-next]');
    var dots = root.querySelectorAll('.hero-carousel__dot');
    var idx = 0;
    function go(n) {
      idx = Math.max(0, Math.min(slides.length - 1, n));
      // Use the slide's exact rounded offsetLeft so we translate by integer pixels.
      // Avoids accumulated sub-pixel drift that leaves seams at slide boundaries.
      var target = slides[idx];
      var px = target ? target.offsetLeft : Math.round(idx * root.offsetWidth);
      track.style.transform = 'translate3d(' + (-px) + 'px, 0, 0)';
      dots.forEach(function (d, i) {
        var on = i === idx;
        d.classList.toggle('is-active', on);
        if (on) d.setAttribute('aria-current', 'true');
        else d.removeAttribute('aria-current');
      });
      if (prev) prev.disabled = idx === 0;
      if (next) next.disabled = idx === slides.length - 1;
    }
    if (prev) prev.addEventListener('click', function () { go(idx - 1); });
    if (next) next.addEventListener('click', function () { go(idx + 1); });
    dots.forEach(function (d, i) { d.addEventListener('click', function () { go(i); }); });
    root.addEventListener('hero-carousel:reset', function () { go(0); });
    var startX = null;
    track.addEventListener('touchstart', function (e) { startX = e.touches[0].clientX; }, { passive: true });
    track.addEventListener('touchend', function (e) {
      if (startX === null) return;
      var endX = (e.changedTouches[0] || {}).clientX || startX;
      var dx = endX - startX;
      if (Math.abs(dx) > 50) go(idx + (dx < 0 ? 1 : -1));
      startX = null;
    });
    root.addEventListener('keydown', function (e) {
      if (!e.target.closest('.hero-carousel__arrow, .hero-carousel__dot')) return;
      if (e.key === 'ArrowLeft')  { e.preventDefault(); go(idx - 1); }
      else if (e.key === 'ArrowRight') { e.preventDefault(); go(idx + 1); }
      else if (e.key === 'Home')  { e.preventDefault(); go(0); }
      else if (e.key === 'End')   { e.preventDefault(); go(slides.length - 1); }
    });
    root.setAttribute('aria-roledescription', 'carousel');
    if (!root.hasAttribute('aria-label')) {
      root.setAttribute('aria-label', 'Product images');
    }
    go(0);
  });
  // Swap visible carousel when the user changes tape style (full / slim).
  document.querySelectorAll('.mp-variant').forEach(function (b) {
    b.addEventListener('click', function () {
      var v = b.getAttribute('data-variant');
      if (!v) return;
      var card = b.closest('.mini-pdp-card');
      if (!card) return;
      card.querySelectorAll('[data-carousel]').forEach(function (root) {
        var match = root.getAttribute('data-variant') === v;
        root.classList.toggle('is-active', match);
        if (match) root.dispatchEvent(new CustomEvent('hero-carousel:reset'));
      });
    });
  });
})();

// Scroll reveal
const obs = new IntersectionObserver((entries) => {
  entries.forEach(e => { if (e.isIntersecting) e.target.classList.add('vis'); });
}, { threshold: 0.12, rootMargin: '0px 0px -60px 0px' });
document.querySelectorAll('.sr,.sr-left,.sr-right,.sr-scale').forEach(el => obs.observe(el));

// Animated counters
const counterObs = new IntersectionObserver((entries) => {
  entries.forEach(e => {
    if (!e.isIntersecting || e.target.dataset.done) return;
    e.target.dataset.done = '1';
    const target = +e.target.dataset.count;
    let cur = 0;
    const step = target / (2000 / 16);
    const t = setInterval(() => {
      cur += step;
      if (cur >= target) { cur = target; clearInterval(t); }
      e.target.textContent = Math.round(cur) + '%';
    }, 16);
  });
}, { threshold: 0.5 });
document.querySelectorAll('[data-count]').forEach(el => counterObs.observe(el));

// Nav background on scroll
const nav = document.querySelector('.nav');
window.addEventListener('scroll', () => {
  if (window.scrollY > 100) {
    nav.style.background = 'rgba(255,250,246,0.95)';
    nav.style.boxShadow = '0 1px 8px rgba(0,0,0,0.04)';
  } else {
    nav.style.background = 'rgba(255,250,246,0.85)';
    nav.style.boxShadow = 'none';
  }
});


// ============================================
// V4 PDP POST-BUY-BOX JS (merged from sleep-karma-pdp-V4.html)
// ============================================
// ============================================
// V4 POST-BUY-BOX JS BLOCK
// Extracted verbatim from sleep-karma-pdp-V4.html
// Includes only handlers that drive post-buy-box sections.
// ============================================

// --- Sticky bar (IntersectionObserver) — lines 2951-2972 ---
// ==================================================
// STICKY BAR — IntersectionObserver
// ==================================================
const heroCta = document.getElementById('add-to-cart-btn');
const finalCta = document.querySelector('.final-cta-button');
const stickyBar = document.getElementById('sticky-bar');
let heroBelowViewport = false, finalCtaVisible = false;
const stickyUpdate = () => stickyBar.classList.toggle('visible', heroBelowViewport && !finalCtaVisible);
const heroObs = new IntersectionObserver((entries) => {
  entries.forEach(e => {
    // Show sticky only when CTA is above viewport (user scrolled past it downward)
    heroBelowViewport = !e.isIntersecting && e.boundingClientRect.top < 0;
    stickyUpdate();
  });
}, { threshold: 0 });
if (heroCta) { heroObs.observe(heroCta); }
if (finalCta) {
  const finalObs = new IntersectionObserver((entries) => {
    entries.forEach(e => { finalCtaVisible = e.isIntersecting; stickyUpdate(); });
  }, { threshold: 0.1 });
  finalObs.observe(finalCta);
}

// --- Materials variant switcher (mat-wrapper section) — lines 2999-3063 ---
// ==================================================
// MATERIALS VARIANT SWITCHER
// ==================================================
const variantData = {
  full: { label: 'Full Coverage', desc: 'Full Coverage for a full mouth seal.<br>Perfect for those who want a complete, snug fit.' },
  slim: { label: 'Slim Profile', desc: 'Slim Profile lies vertically across the lips for minimal feel.<br>Perfect for beginners or those with extra sensitive skin.' }
};
let currentVariant = 'full';
function goToVariant(v) {
  if (v === currentVariant) return;
  const panels = document.querySelectorAll('.variant-slide-panel');
  const exitIdx = currentVariant === 'full' ? 0 : 1;
  // Fade out the panel we're leaving
  panels[exitIdx].classList.add('exiting');
  currentVariant = v;
  document.getElementById('variantSlide').classList.toggle('show-slim', v === 'slim');
  document.getElementById('variantDesc').innerHTML = variantData[v].desc;
  document.querySelectorAll('.variant-pill-btn').forEach(btn => {
    btn.classList.toggle('active', btn.dataset.variant === v);
  });
  document.querySelector('.variant-arrow.arrow-left').classList.toggle('disabled', v === 'full');
  document.querySelector('.variant-arrow.arrow-right').classList.toggle('disabled', v === 'slim');
  // Toggle nav hint arrows — hide outgoing immediately, show incoming after slide completes
  if (v === 'slim') {
    document.getElementById('slideHintRight').style.display = 'none';
    setTimeout(() => { document.getElementById('slideHintLeft').style.display = ''; }, 1200);
  } else {
    document.getElementById('slideHintLeft').style.display = 'none';
    setTimeout(() => { document.getElementById('slideHintRight').style.display = ''; }, 1200);
  }
  // Remove exiting class after transition completes
  setTimeout(() => { panels[exitIdx].classList.remove('exiting'); }, 1100);
}
function switchVariant(dir) {
  if (dir === 'next' && currentVariant === 'full') goToVariant('slim');
  if (dir === 'prev' && currentVariant === 'slim') goToVariant('full');
}

// Drag / swipe to switch variant
(function() {
  var wrapper = document.querySelector('.variant-slide-wrapper');
  if (!wrapper) return; // Variant section removed from homepage
  var startX = 0, isDragging = false, threshold = 60;

  function onStart(e) {
    isDragging = true;
    startX = e.type.includes('mouse') ? e.clientX : e.touches[0].clientX;
    wrapper.style.cursor = 'grabbing';
  }
  function onEnd(e) {
    if (!isDragging) return;
    isDragging = false;
    wrapper.style.cursor = 'grab';
    var endX = e.type.includes('mouse') ? e.clientX : e.changedTouches[0].clientX;
    var diff = endX - startX;
    if (diff < -threshold) switchVariant('next');
    else if (diff > threshold) switchVariant('prev');
  }
  function onCancel() { isDragging = false; wrapper.style.cursor = 'grab'; }

  wrapper.addEventListener('mousedown', onStart);
  window.addEventListener('mouseup', onEnd);
  window.addEventListener('mouseleave', onCancel);
  wrapper.addEventListener('touchstart', onStart, { passive: true });
  wrapper.addEventListener('touchend', onEnd);
})();

// --- FAQ toggle (faq-section) — lines 3084-3107 ---
// ==================================================
// FAQ TOGGLE (smooth animated version)
// ==================================================
function toggleFAQ(btn) {
  const item = btn.parentElement;
  const answer = item.querySelector('.faq-answer');
  const isOpen = item.classList.contains('open');

  if (isOpen) {
    answer.style.maxHeight = '0';
    answer.style.padding = '0';
    item.classList.remove('open');
  } else {
    item.classList.add('open');
    answer.style.maxHeight = answer.scrollHeight + 'px';
    answer.style.padding = '0 0 20px';
  }
}

// Initialize open FAQ items
document.querySelectorAll('.faq-item.open .faq-answer').forEach(answer => {
  answer.style.maxHeight = answer.scrollHeight + 'px';
  answer.style.padding = '0 0 20px';
});

// --- Scroll reveal + animated stat counters — lines 3127-3174 ---
// ==================================================
// SCROLL REVEAL — IntersectionObserver
// ==================================================
const revealObserver = new IntersectionObserver((entries) => {
  entries.forEach(entry => {
    if (entry.isIntersecting) {
      entry.target.classList.add('visible');

      // Trigger stat counter animation if this is a stat card
      const statEl = entry.target.querySelector('.stat-number[data-count]');
      if (statEl && !statEl.dataset.animated) {
        animateCounter(statEl);
        statEl.dataset.animated = 'true';
      }
    }
  });
}, {
  threshold: 0.15,
  rootMargin: '0px 0px -40px 0px'
});

document.querySelectorAll('.reveal, .reveal-left, .reveal-right, .reveal-scale').forEach(el => {
  revealObserver.observe(el);
});

// ==================================================
// ANIMATED STAT COUNTERS
// ==================================================
function animateCounter(el) {
  const target = parseInt(el.dataset.count);
  const duration = 1800;
  const start = performance.now();

  function update(now) {
    const elapsed = now - start;
    const progress = Math.min(elapsed / duration, 1);
    // Ease out cubic
    const eased = 1 - Math.pow(1 - progress, 3);
    const current = Math.round(target * eased);
    el.textContent = current + '%';

    if (progress < 1) {
      requestAnimationFrame(update);
    }
  }

  requestAnimationFrame(update);
}

// --- Video modal + show-more-reviews — lines 3184-3228 ---
function openVideoModal(src) {
  const modal = document.getElementById('videoModal');
  const video = document.getElementById('modalVideo');
  video.src = src;
  modal.style.display = 'flex';
  requestAnimationFrame(() => {
    modal.classList.add('active');
    video.play();
  });
  document.body.style.overflow = 'hidden';
}

function closeVideoModal(e) {
  if (e && e.target !== e.currentTarget && !e.target.classList.contains('video-modal-close')) return;
  const modal = document.getElementById('videoModal');
  const video = document.getElementById('modalVideo');
  video.pause();
  video.src = '';
  modal.classList.remove('active');
  setTimeout(() => { modal.style.display = 'none'; }, 300);
  document.body.style.overflow = '';
}

document.addEventListener('keydown', function(e) {
  if (e.key === 'Escape') closeVideoModal({target: document.getElementById('videoModal'), currentTarget: document.getElementById('videoModal')});
});

function toggleMoreReviews() {
  const grid = document.querySelector('.sp-grid');
  const btn = document.getElementById('sp-show-more-btn');
  const isExpanded = grid.classList.contains('sp-expanded');
  if (!isExpanded) {
    grid.classList.add('sp-expanded');
    btn.classList.add('expanded');
    btn.innerHTML = 'Show Less <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="6 9 12 15 18 9"></polyline></svg>';
    // Stagger the animation
    grid.querySelectorAll('.sp-more-item').forEach(function(item, i) {
      item.style.animationDelay = (i * 0.06) + 's';
    });
  } else {
    grid.classList.remove('sp-expanded');
    btn.classList.remove('expanded');
    btn.innerHTML = 'Show More Reviews <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="6 9 12 15 18 9"></polyline></svg>';
  }
}



// Product category tabs — visual toggle + content swap via swapProduct().
// Also paints `.cat-tab--adj-active` on the segment immediately after the active
// one, so the hairline divider between active and the next inactive disappears
// (Apple-style segmented control behavior).
(function() {
  document.querySelectorAll('.cat-tabs').forEach(function(group) {
    var btns = Array.prototype.slice.call(group.querySelectorAll('.cat-tab'));
    function paintAdj() {
      btns.forEach(function(b, i) {
        b.classList.remove('cat-tab--adj-active');
        if (b.classList.contains('is-active') && btns[i + 1]) {
          btns[i + 1].classList.add('cat-tab--adj-active');
        }
      });
    }
    btns.forEach(function(b) {
      b.addEventListener('click', function() {
        btns.forEach(function(x) {
          x.classList.remove('is-active');
          x.setAttribute('aria-selected', 'false');
        });
        b.classList.add('is-active');
        b.setAttribute('aria-selected', 'true');
        paintAdj();
        var pid = b.getAttribute('data-pid');
        if (pid && typeof window.swapProduct === 'function') {
          window.swapProduct(pid);
        }
      });
    });
    paintAdj();
  });
})();

// ============================================
// SHOPIFY ATC INTEGRATION (Sleep Karma — homepage)
// Overrides mp-cta and mp-simple-cta link-redirect behavior with a real
// /cart/add.js POST and cart-drawer open. Mirrors the flow used by
// /pages/mouth-tape-a (assets/sleep-karma-pdp.js).
// ============================================
(function() {
  // Variant + selling-plan IDs sourced from sleep-karma-pdp.js (live PDP).
  // Mouth tape: Tape style × Frequency = 6 variants. Quantity = pack number (1/3/6).
  var SK_VARIANTS = {
    mouth: {
      'full-1': 46066516656369, 'full-3': 46072098324721, 'full-6': 46072098357489,
      'slim-1': 46066516721905, 'slim-3': 46072098390257, 'slim-6': 46072098423025
    },
    nose:   { '1': 46045510107377, '3': 46045510172913, '6': 46045510238449 },
    ear:    46095730376945,
    holder: 46045513154801,
    travel: 46045514629361
  };
  var SK_SELLING_PLANS = { '1': 5171773681, '3': 5171740913, '6': 5171806449 };

  function readState() {
    var section = document.getElementById('variant-section');
    if (!section) return null;
    var activeTab = section.querySelector('.cat-tab.is-active');
    var product = activeTab ? activeTab.getAttribute('data-pid') : 'mouth';
    var activeVariant = section.querySelector('.mp-variant.is-selected');
    var variant = activeVariant ? activeVariant.getAttribute('data-variant') : 'full';
    var activePack = section.querySelector('.mp-pack.is-selected');
    var pack = activePack ? activePack.getAttribute('data-pack') : '3';
    var refillBtn = document.getElementById('mp-refill');
    var isSub = refillBtn ? refillBtn.classList.contains('is-active') : true;
    return { product: product, variant: variant, pack: pack, isSub: isSub };
  }

  function buildPayload(state) {
    var p = state.product;
    if (p === 'mouth') {
      var key = state.variant + '-' + state.pack;
      var id = SK_VARIANTS.mouth[key];
      var qty = parseInt(state.pack, 10) || 1;
      var payload = { id: id, quantity: qty };
      if (state.isSub) payload.selling_plan = SK_SELLING_PLANS[state.pack];
      return payload;
    }
    if (p === 'nose') {
      // Nose tape variants are themselves N-month bundles (price scales with
      // duration), so qty is always 1 — the matched variant + matching plan
      // already encodes the correct supply length and discount. Multiplying
      // qty by months would charge for N² months. (Mouth-tape's variants
      // are per-unit priced, so qty scaling works there — that branch above
      // uses qty = pack number.)
      var id = SK_VARIANTS.nose[state.pack];
      var payload = { id: id, quantity: 1 };
      if (state.isSub) payload.selling_plan = SK_SELLING_PLANS[state.pack];
      return payload;
    }
    var simpleId = SK_VARIANTS[p];
    if (typeof simpleId === 'number') return { id: simpleId, quantity: 1 };
    return null;
  }

  function ajaxCartAdd(payload) {
    var cartDrawer = document.querySelector('cart-drawer');
    var sectionsToRender = (cartDrawer && cartDrawer.getSectionsToRender)
      ? cartDrawer.getSectionsToRender().map(function(s) { return s.id; })
      : ['cart-drawer', 'cart-icon-bubble'];
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [payload], sections: sectionsToRender.join(',') })
    })
    .then(function(r) {
      if (!r.ok) {
        return r.json().then(function(err) { throw err; }, function() { throw new Error('cart/add ' + r.status); });
      }
      return r.json();
    })
    .then(function(data) {
      if (cartDrawer && cartDrawer.renderContents && data.sections) {
        cartDrawer.renderContents(data, true);
        setTimeout(function() {
          if (!cartDrawer.isOpen) cartDrawer.toggleDrawerClasses();
        }, 100);
      } else {
        var trigger = document.querySelector('.wt-cart__trigger, #cart-icon-bubble, a[href="/cart"]');
        if (trigger) trigger.click();
      }
    });
  }

  function intercept(e) {
    e.preventDefault();
    var btn = this;
    if (btn.dataset.busy === '1') return;
    btn.dataset.busy = '1';
    var origHTML = btn.innerHTML;
    btn.innerHTML = '<span style="font-size:14px;letter-spacing:0;">Adding to cart...</span>';
    btn.style.pointerEvents = 'none';
    var state = readState();
    var payload = state ? buildPayload(state) : null;
    if (!payload || !payload.id) {
      console.error('[home-v2] no variant for state', state);
      btn.innerHTML = '<span style="font-size:14px;letter-spacing:0;">Error — try again</span>';
      setTimeout(function() { btn.innerHTML = origHTML; btn.style.pointerEvents = ''; btn.dataset.busy = ''; }, 1800);
      return;
    }
    ajaxCartAdd(payload).then(function() {
      btn.innerHTML = '<span style="font-size:14px;letter-spacing:0;">Added!</span>';
      setTimeout(function() { btn.innerHTML = origHTML; btn.style.pointerEvents = ''; btn.dataset.busy = ''; }, 1200);
    }).catch(function(err) {
      console.error('[home-v2] cart add failed', err);
      btn.innerHTML = '<span style="font-size:14px;letter-spacing:0;">Error — try again</span>';
      setTimeout(function() { btn.innerHTML = origHTML; btn.style.pointerEvents = ''; btn.dataset.busy = ''; }, 1800);
    });
  }

  function init() {
    var ctaBtn = document.getElementById('add-to-cart-btn');
    var simpleBtn = document.getElementById('mp-simple-cta');
    if (ctaBtn) ctaBtn.addEventListener('click', intercept);
    if (simpleBtn) simpleBtn.addEventListener('click', intercept);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

// ============================================
// HERO BANNER CLICK-THROUGH
// Make the entire hero clickable (matches the old homepage's behavior).
// Skip clicks that landed on a real interactive child (the existing CTA <a>,
// any button, link, or form control) so those keep their native behavior.
// ============================================
(function() {
  function initHeroLinks() {
    document.querySelectorAll('[data-hero-link]').forEach(function(hero) {
      hero.style.cursor = 'pointer';
      hero.addEventListener('click', function(e) {
        if (e.target.closest('a, button, input, select, textarea, label, [role="button"]')) return;
        var href = hero.getAttribute('data-hero-link');
        if (href) window.location.href = href;
      });
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initHeroLinks);
  } else {
    initHeroLinks();
  }
})();
